// extracted by mini-css-extract-plugin
export var row = "_tr-0";